const optionsCache = new Map();

export const getOptions = async (url) => {
  if (optionsCache.has(url)) {
    return optionsCache.get(url);
  }

  const request = await fetch(url);
  const data = await request.json();
  const options = data.map((option) => ({
    value: option.value,
    label: option.label,
  }));
  optionsCache.set(url, options);

  return options;
};
